import BaseController from '../../lib/BaseController';
import ajax from '../../services/Ajax';
import notification from '../../services/Notification';
class SafteyAwarenessController extends BaseController {
  constructor() {
    super('login-reset-password', {
      loginname: '',
      error: '',
      isLoading: false
    });
  }
  
}
export default SafteyAwarenessController;